import { zeroPadding } from "./NumberUtil";
import * as Const from "@/config/const.js";

export const toHourFormat = seconds => {
  let totalMibutes = parseInt(seconds / 60.0);
  let hours = parseInt(totalMibutes / 60);
  let minutes = totalMibutes % 60;
  return hours + ":" + zeroPadding(minutes, 2);
};

export const toDistanceFormat = distance => {
  return Math.round((distance / Const.MILE) * 10) / 10;
};
